<template>
    <div
        :dark="$theme.dark"
        outline
        class="app-toolbar-item"
        :class="[item.active ? 'app-toolbar-item--active' : '', item.disabled ? 'app-toolbar-item--disabled' : '', item.class ? item.class : '']"
        @click="item.disabled ? '' : item.callback(item)"
    >

        <mdi :key="item.mdi" v-if="item.mdi" :class="item.iconClass ? item.iconClass : ''" :style="item.iconStyle ? item.iconStyle : ''">
            {{ item.mdi }}
        </mdi>

        <v-icon v-else :class="item.iconClass ? item.iconClass : ''" :style="item.iconStyle ? item.iconStyle : ''">
            {{ item.icon }}
        </v-icon>

        <span class="app-toolbar-item-badge" v-if="item.badge && item.badge() !== null">{{ item.badge() }}</span>

        <span class="app-toolbar-btn-text roboto bold--text" :style="item.textStyle ? item.textStyle : ''">{{ item.text }}</span>
    </div>
</template>

<style>
    .app-toolbar-item-badge {
        position: absolute;
        margin: -30px 0 0 20px;
        display: block;
        width: 16px;
        height: 16px;
        line-height:16px;
        text-align: center;
        background:red;
        font-weight: 600;
        border-radius:50%;

    }

    .app-toolbar-item-badge:before {
        content: "";
        display: block;
        border: 1px solid white;
        animation: badgePulse 2s infinite;
        width: 16px;
        height: 16px;
        border-radius:50%;
        position: absolute;
    }


    @keyframes badgePulse {
	0% {
        transform: scale(1);
        opacity: 1;
	}

	70% {
		transform: scale(2);
	}

	100% {
		transform: scale(2);
        opacity: 0;
	}
}

    .app-toolbar-item {
        flex-grow: 0;
        flex-shrink: 0;
        width: 25vw;
        text-align: left;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 11px;
        height: 72px;
        position: relative;
    }

    .app-toolbar-item {
        color: #eee;
    }

    .app-toolbar-item .v-icon {
        color: #ddd;
    }

    .app-toolbar-item--active:after {
        display: block;
        content: "";
        position: absolute;
        bottom: 2px;
        left: 50%;
        margin-left: -40%;
        width: 80%;
        height: 4px;
    }

    .app-toolbar-photos .app-toolbar-item--active:after {
        background: rgb(141 194 67);
    }

    .app-toolbar-videos .app-toolbar-item--active:after {
        background: rgb(243, 187, 1);
    }

    .app-toolbar-plan .app-toolbar-item--active:after {
        background: rgb(236, 60, 122);
    }

    .app-toolbar-support .app-toolbar-item--active:after {
        background: rgb(236, 60, 122);
    }

    .app-toolbar-tutorials .app-toolbar-item--active:after {
        background: rgb(236, 60, 122);
    }

    .app-toolbar-faq .app-toolbar-item--active:after {
        background: rgb(236, 60, 122);
    }

    /*.app-toolbar-item--active, .app-toolbar-item--active .v-icon {
        color: #000;
    }*/

    .app-toolbar-item--disabled, .app-toolbar-item--disabled .v-icon {
        color: #ddd;
    }

    .app-toolbar-item .v-icon {
        margin: 3px;
    }

    .app-back-button-icon .v-icon {
        background: rgba(255,255,255,.2);
        padding: 3px 4px 3px 2px;
        border-radius: 50%;
        color: #ddd!important;
    }

@media (min-width: 700px) {
    .app-toolbar-item {
        height: 70px !important;
        font-size: 16px;
    }

    .app-toolbar-item i {
        font-size: 26px;
        margin-right: 8px !important;
    }

    .app-toolbar-item svg {
        margin-right: 8px !important;
    }

    .app-toolbar-item {
        flex-direction: row;
    }

    .app-back-button-icon i {
        font-size: 32px !important;
    }

    .app-toolbar-item-badge {
        margin: -15px 3px 0px -18px;
        position: relative;
    }
}
</style>

<script>
export default {
    props: {
        item: {
            type: Object,
        },
    },
}
</script>
